import { useCallback, useEffect } from "react";
import { KEY_CODE } from "../../../../../types/key-code.js";
const useKeydown = (props, propsOnChange)=>{
    const { store , selectingSuggestion , setValue , openSuggestions , cancelSuggestion , confirmSuggestion  } = props;
    const arrowUpDownHandler = useCallback((eventKey)=>{
        const suggestions = store.suggestions.flatMap((x)=>x.suggestions);
        let index = suggestions.findIndex((x)=>x.id === store.selectingSuggestion?.id);
        const nextElement = eventKey === KEY_CODE.ARROW_DOWN ? 1 : -1;
        index = index + nextElement;
        openSuggestions();
        if (0 <= index && index < suggestions.length) {
            selectingSuggestion(suggestions[index]);
            setValue(suggestions[index].text);
        }
    }, [
        store.selectingSuggestion?.id,
        store.suggestions,
        openSuggestions,
        selectingSuggestion,
        setValue
    ]);
    const pressHandler = useCallback((event)=>{
        if (!store.showSuggestions) return;
        switch(event.key){
            case KEY_CODE.ARROW_UP:
            case KEY_CODE.ARROW_DOWN:
                event.preventDefault();
                arrowUpDownHandler(event.key);
                break;
            case KEY_CODE.ENTER:
                event.preventDefault();
                event.stopPropagation();
                propsOnChange?.(store.selectingSuggestion);
                confirmSuggestion(store.selectingSuggestion);
                break;
            case KEY_CODE.TAB:
                propsOnChange?.(store.selectingSuggestion);
                confirmSuggestion(store.selectingSuggestion);
                break;
            case KEY_CODE.ESC:
                event.stopPropagation();
                cancelSuggestion();
                break;
            default:
                break;
        }
    }, [
        store.showSuggestions,
        store.selectingSuggestion,
        arrowUpDownHandler,
        confirmSuggestion,
        propsOnChange,
        cancelSuggestion
    ]);
    useEffect(()=>{
        window.addEventListener('keydown', pressHandler, {
            capture: true
        });
        return ()=>{
            window.removeEventListener('keydown', pressHandler, {
                capture: true
            });
        };
    }, [
        pressHandler,
        store
    ]);
};
export default useKeydown;

//# sourceMappingURL=useKeydown.js.map